// extracted by mini-css-extract-plugin
export default {"nav-wrap":"nav-wrap__UwhUi","nav--main__item":"nav--main__item__s0pGk","nav--main":"nav--main__DFX0d"};